import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-2 text-sm text-foreground-500">
      {items.map((item, idx) => {
        const isLast = idx === items.length - 1;
        return (
          <span key={`${item.label}-${idx}`} className="flex items-center gap-2">
            {item.to && !isLast ? (
              <Link to={item.to} className="whitespace-nowrap transition-colors hover:text-primary-600 cursor-pointer">
                {item.label}
              </Link>
            ) : (
              <span className={isLast ? "whitespace-nowrap text-foreground-800" : "whitespace-nowrap"}>
                {item.label}
              </span>
            )}
            {!isLast && <i className="ri-arrow-right-s-line text-base text-foreground-300" aria-hidden="true"></i>}
          </span>
        );
      })}
    </nav>
  );
}